import React from 'react';
import PropTypes from 'prop-types';

const Input = (props) => {
  let size = "";
  switch(props.size){
    case 'lg': size = "input-lg"; break;
    case 'md': size = ""; break;
    case 'sm':
    default: size = "input-sm" //keep default as input-small for any other size provide own case or make wrapper component that injects the size desired
  }
  const validationClass = props.isValid ? "":"input-error";
  return props.type === 'checkbox' ? (
    <input
      className={`${props.class} ${validationClass}`}
      type={props.type}
      checked={props.checked}
      disabled={props.isDisabled}
      ref={props.inputRef}
      onChange={(e) => { props.onChange(props.property,e.target.value, props.isRequired, e) }}
      onBlur={(e) => { props.onBlur && props.onBlur(props.property, e.target.value, props.isRequired, e) }}
      onFocus={(e) => { props.onFocus && props.onFocus(props.property, e.target.value, props.isRequired, e) }}
    />
  ):(
    <input
      className={`form-control ${size} ${props.class} ${validationClass}`}
      type={props.type}
      placeholder={props.placeholder}
      value={props.value}
      disabled={props.isDisabled}
      ref={props.inputRef}
      onChange={(e) => { props.onChange(props.property,e.target.value, props.isRequired, e) }}
      onBlur={(e) => { props.onBlur && props.onBlur(props.property, e.target.value, props.isRequired, e) }}
      onFocus={(e) => { props.onFocus && props.onFocus(props.property, e.target.value, props.isRequired, e) }}
      />
  )

}

Input.propTypes = {
  property: PropTypes.string.isRequired,
  onChange:PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  type: PropTypes.string,
  value: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'lg']),
  class: PropTypes.string,
  placeholder: PropTypes.string,
  isValid: PropTypes.bool,
  isRequired: PropTypes.bool,
  isDisabled: PropTypes.bool,
  inputRef: PropTypes.any,
}

Input.defaultProps = {
  type: "text",
  value: "",
  class: "",
  size: "sm",
  placeholder: "",
  isValid: true,
  isRequired: false,
  isDisabled: false,
}

export default Input
